import type { ReactNode } from 'react';

import {
  WidgetSitePanelContext,
  type WidgetSitePanelContextValue,
} from './widgetSitePanelProvider/WidgetSitePanelContext.ts';

type WidgetSitePanelProviderProps = WidgetSitePanelContextValue & {
  children: ReactNode;
};

export const WidgetSitePanelProvider = ({
  section,
  onSave,
  registerSave,
  children,
}: WidgetSitePanelProviderProps) => (
  <WidgetSitePanelContext.Provider value={{ section, onSave, registerSave }}>
    {children}
  </WidgetSitePanelContext.Provider>
);
